module.exports = __webpack_public_path__ + "img/新闻中心banner1920x280px.9a8d67ae.png";